export default __webpack_public_path__ + "static/media/frontendcv.0cc77ca6.pdf";